import { isHttpsUrl } from "./apiEmptyList";

export const TIER_PLACEMENTS = {
    GOLD: ["HOME_SCREEN", "EVENT_PAGE", "PROFILE_PAGE", "SPONSOR_SECTION"],
    SILVER: ["EVENT_PAGE", "PROFILE_PAGE", "SPONSOR_SECTION"],
    BRONZE: ["SPONSOR_SECTION"],
};

const CREATIVE_PATH = /^\/api\/v1\/advertisement\/creatives\/[^/?#]+$/;

export const isAllowedAssetUrl = (value) => {
    if (!value) {
        return true;
    }
    return CREATIVE_PATH.test(value) || isHttpsUrl(value);
};

export const resolveCreativeUrl = (imageUrl) => {
    if (!imageUrl) {
        return "";
    }
    if (isHttpsUrl(imageUrl)) {
        return imageUrl;
    }
    const match = imageUrl.match(/\/advertisement\/creatives\/(.+)$/);
    if (match && import.meta.env.VITE_APP_BASE_URL) {
        return `${import.meta.env.VITE_APP_BASE_URL}/advertisement/creatives/${match[1]}`;
    }
    return imageUrl;
};

export const placementAllowedForTier = (tier, placement) => {
    const allowed = TIER_PLACEMENTS[tier] || TIER_PLACEMENTS.BRONZE;
    return allowed.includes(placement);
};

export const placementsForSponsorship = (sponsorshipId, sponsorships = []) => {
    if (!sponsorshipId) {
        return [...TIER_PLACEMENTS.GOLD];
    }
    const deal = (sponsorships || []).find((item) => item.id === sponsorshipId);
    return [...(TIER_PLACEMENTS[deal?.tier] || TIER_PLACEMENTS.BRONZE)];
};

export const bannerPlacementAllowed = (sponsorshipId, placement, sponsorships = []) =>
    placementsForSponsorship(sponsorshipId, sponsorships).includes(placement);

const shuffle = (items) => {
    const copy = [...items];
    for (let i = copy.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
};

export const honorDisplayBanners = (banners, { placement, sponsorships = [], isFreePlan = true } = {}) => {
    if (!isFreePlan && placement !== "SPONSOR_SECTION") {
        return [];
    }
    const tierBySponsorship = Object.fromEntries(
        (sponsorships || []).map((deal) => [deal.id, deal.tier])
    );
    const filtered = (banners || []).filter((banner) => {
        if (banner.placement && placement && banner.placement !== placement) {
            return false;
        }
        if (!banner.sponsorshipId) {
            return true;
        }
        const tier = tierBySponsorship[banner.sponsorshipId];
        if (!tier) {
            return true;
        }
        return placementAllowedForTier(tier, placement);
    });
    const sorted = [...filtered].sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0));
    if (placement === "HOME_SCREEN") {
        if (sorted.length === 0) {
            return [];
        }
        const topPriority = sorted[0].priority ?? 0;
        return shuffle(sorted.filter((banner) => (banner.priority ?? 0) === topPriority)).slice(0, 2);
    }
    return sorted;
};
